"use strict";

exports.__esModule = true;
exports.default = setTransition;

function setTransition(duration, byController) {
  var swiper = this;

  if (!swiper.params.cssMode) {
    swiper.$wrapperEl.transition(duration);
  }

  swiper.emit('setTransition', duration, byController);
}


//////////////////
// WEBPACK FOOTER
// ./~/swiper/cjs/components/core/transition/setTransition.js
// module id = 68
// module chunks = 0